import { render, staticRenderFns } from "./PatientVoiceTab.vue?vue&type=template&id=27cd613c&scoped=true"
import script from "./PatientVoiceTab.vue?vue&type=script&lang=js"
export * from "./PatientVoiceTab.vue?vue&type=script&lang=js"
import style0 from "./PatientVoiceTab.vue?vue&type=style&index=0&id=27cd613c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd613c",
  null
  
)

export default component.exports